import GenericRequest, { METHOD_GET } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class DocumentStateListTask extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.DOCUMENT_STATES);
    }

    overrideRequest() {}
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/document-state-list/DocumentStateListTask.js